module.exports = __webpack_public_path__ + "static/media/alpha_18.80b0dd8e.png";